const inprogress2 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="8 4 8 8 12 8"/></svg>',
};

export { inprogress2 as default };
